import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const gsapFullsizeVideo = (function ($) {

    gsap.registerPlugin(ScrollTrigger);

    let $fixedContainer = gsap.utils.toArray(".js-gsap-fullsize-video");

    function init() {

        if ($fixedContainer) {
            ScrollTrigger.matchMedia({
                // desktop
                "(min-width: 1024px) and (prefers-reduced-motion: no-preference)": function() {
                    // pinned element only on desktop
                    $fixedContainer.forEach(function(elem) {

                        let tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: elem,
                                scrub: 1,
                                pin: false,
                                start: "center bottom",
                                end: "+=50%",
                                // once: true
                            }
                        });

                        tl.fromTo(elem, {scale: 0.7}, {scale: 1});

                    })
                },
                // mobile
                "(max-width: 1023px)": function() {

                }
            })

        }

    }

    return {
        init: init
    }

})(jQuery);